import { apiClient } from './api/apiClient';
import { Site, CreateSiteRequest, UpdateSiteRequest, SiteFilter, PagedResponse, ApiResponse } from '../types';

class SiteService {
  /**
   * Ottieni lista sedi con filtri e paginazione
   */
  async getSites(filter?: SiteFilter): Promise<PagedResponse<Site>> {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.companyId) params.append('companyId', filter.companyId.toString());
      if (filter.isActive !== undefined) params.append('isActive', filter.isActive.toString());
      if (filter.search) params.append('search', filter.search);
      if (filter.page) params.append('page', filter.page.toString());
      if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
    }

    return await apiClient.get<PagedResponse<Site>>(
      `/sites?${params.toString()}`
    );
  }

  /**
   * Ottieni dettagli sede per ID
   */
  async getSiteById(id: number): Promise<ApiResponse<Site>> {
    return await apiClient.get<ApiResponse<Site>>(`/sites/${id}`);
  }

  /**
   * Crea nuova sede
   */
  async createSite(data: CreateSiteRequest): Promise<ApiResponse<Site>> {
    return await apiClient.post<ApiResponse<Site>>('/sites', data);
  }

  /**
   * Aggiorna sede esistente
   */
  async updateSite(id: number, data: UpdateSiteRequest): Promise<ApiResponse<Site>> {
    return await apiClient.put<ApiResponse<Site>>(`/sites/${id}`, data);
  }

  /**
   * Disattiva sede (soft delete)
   */
  async deactivateSite(id: number): Promise<void> {
    return await apiClient.delete(`/sites/${id}`);
  }
}

export const siteService = new SiteService();
